import { render, staticRenderFns } from "./HeaderLinks.vue?vue&type=template&id=11459e18&scoped=true&"
import script from "./HeaderLinks.vue?vue&type=script&lang=ts&"
export * from "./HeaderLinks.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderLinks.vue?vue&type=style&index=0&id=11459e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11459e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('11459e18', component.options)
    } else {
      api.reload('11459e18', component.options)
    }
    module.hot.accept("./HeaderLinks.vue?vue&type=template&id=11459e18&scoped=true&", function () {
      api.rerender('11459e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/HeaderLinks.vue"
export default component.exports